import { RiFileHistoryLine } from "@itandi/itandi-bb-ui";
import { Box } from "@itandi/itandi-bb-ui/Box";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import clsx from "clsx";
import Link from "next/link";
import type { DealEstimationHeader } from "~/models/DealEstimationHeader";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import { formatDate } from "~/utils/DateUtil";
import Styles from "./EstimationHistoryNavigation.module.scss";

type Props = {
	dealEstimationHeaders: DealEstimationHeader[];
	detailPagePath: (headerId: number) => string;
	ownManagement?: boolean;
};

export function EstimationHistoryNavigation({
	detailPagePath,
	dealEstimationHeaders,
	ownManagement = false
}: Props) {
	if (dealEstimationHeaders?.length === 0) return null;
	return (
		<div className={Styles.NavigationBlock}>
			<div className={Styles.IconWrapper}>
				<RiFileHistoryLine className={Styles.Icon} />
			</div>
			<Box marginBottom=".5rem" width="100%">
				<h1 className={Styles.Title}>
					{`${!ownManagement ? "提出された" : ""}工事見積書一覧`}
				</h1>
				{dealEstimationHeaders.map(
					(dealEstimationHeader: DealEstimationHeader) => (
						<Flex
							alignItems="center"
							key={dealEstimationHeader.id}
							marginBottom=".5rem"
							marginTop={ownManagement ? "0" : ".5rem"}
						>
							<Flex direction="column" gap=".25rem">
								{!ownManagement && (
									<div>
										提出日：{formatDate(dealEstimationHeader.requestedAt, true)}{" "}
										提出者：
										{dealEstimationHeader.staffName
											? dealEstimationHeader.staffName
											: dealEstimationHeader.vendorUserName}
									</div>
								)}
								<div className={clsx(!ownManagement && Styles.SubText)}>
									見積り件数：{dealEstimationHeader.count}件 合計金額： ¥
									{toThousandSeparator(
										dealEstimationHeader.confirmedTotalAmountWithTax
									)}
									(税込)
								</div>
							</Flex>
							<Grid marginLeft="auto">
								<Link
									className={Styles.DetailLink}
									href={detailPagePath(dealEstimationHeader.id)}
								>
									詳細確認
								</Link>
							</Grid>
						</Flex>
					)
				)}
			</Box>
		</div>
	);
}
